module.exports = __webpack_public_path__ + "static/media/Jeep-Wrangler-JL.bf7044a8.jpg";